// Library Methods
import { useContext } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HeadsetFitCard from "../shared/HeadsetFitCard";
import SummarySection from "./SummarySection/SummarySection";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

const FusionAndVergenceGraph = () => {
  const { t } = useTranslation();
  const { examReport } = useContext(ReportSectionContext);

  const summary = examReport?.postProcessing?.summary;
  const fusionalAmplitudes = summary?.FusionalAmplitudes;
  const vergenceFunction = summary?.VergenceFunction;

  if (!fusionalAmplitudes && !vergenceFunction) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
          {t("No Data Available.")}
        </Typography>
      </Box>
    );
  }

  const calibration = examReport?.postProcessing?.calibration;
  const eyeModel = examReport?.postProcessing?.eyeModel;

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="8px">
      {/* The headset leads, as on every other section. */}
      <HeadsetFitCard
        residualDegrees={calibration?.residualDegrees}
        qualityFloorMet={calibration?.qualityFloorMet}
        interpupillaryDistanceMetres={eyeModel?.interpupillaryDistanceMetres}
        interpupillaryDistanceMeasured={
          eyeModel?.interpupillaryDistanceMeasured
        }
      />
      {/* The per-flip facility chart is read off the verbose module block: the summary
          carries only the aggregates. */}
      <SummarySection
        summary={examReport?.postProcessing?.summary}
        modules={examReport?.postProcessing?.modules}
      />
    </Box>
  );
};

export default FusionAndVergenceGraph;
